module.exports = __webpack_public_path__ + "static/media/KMH_5362.fdf8d1be.jpg";